import { Flex, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'

export interface ProgressBarIProps {
  height?: string
  value: number
  barColour?: string
  barBgColour?: string
  showValue?: boolean
}

export const ProgressBar = ({
  height = '10px',
  barColour,
  barBgColour,
  value,
  showValue = true,
}: ProgressBarIProps) => {
  const valuePercentage = `${value}%`
  return (
    <Flex alignItems='center' my='4px' width='100%'>
      <Flex bg={barBgColour} borderRadius='20px' h={height} width='100%'>
        <Flex
          animate={{ width: valuePercentage }}
          as={motion.div}
          bg={barColour}
          borderRadius='20px'
        />
      </Flex>

      {showValue && (
        <Text color={barColour} fontSize='12px' fontWeight={400} ml='8px'>
          {valuePercentage}
        </Text>
      )}
    </Flex>
  )
}
